import React from 'react';
import Button from './Button';
import Image from './Image';
import Logo from '../images/logo.svg';
import Navmenu from './Navmenu';
import FoldNav from './smallComponent/FoldNav';



export default function Nav(){
    return(
     <div className="nav">
      <div className="left"><Image src={Logo}/></div>
      <div className="middle"><Navmenu /></div>
      <div className="right"><Button type="submit" value="Request Invite"/></div>
      <FoldNav className="fold" />
   </div>
    )
}